import http from './http';

export default {
  emailAttachment(data) {
    return http().post(`/v1/download/email_attachments`, data, {responseType: 'blob'});
  }
}
